import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { PageHandler } from "../../../library-js/dom-tools/PageHandler";
import { LanguageCode, LanguageCodes } from "../../../library-js/i18n/LanguageCode";
import { MultiString } from "../../../library-js/i18n/MultiString";
import { EmailInput, UserSignUpRequest } from "../../../library-js/php/user/UserSignUpRequest";
import { TemplatesList } from "../../templates/TemplatesList";
import { EmailOverlay } from "../overlay/EmailOverlay";
import { Rokojori } from "../Rokojori";
import { RokojoriUser } from "./RokojoriUser";


export class ForgotPasswordOverlay
{
  static readonly attribute = new ElementAttribute( "forgot-password" );

  static applyOnDocument()
  {
    ForgotPasswordOverlay.attribute.forEachInDoc( e => ForgotPasswordOverlay.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {  
    let functionName:MultiString =
    {
      en:"forgot-password",
      de:"passwort-vergessen"
    }; 

    PageHandler.setFunctionHandleLink( e,  Rokojori.locale( functionName ),
      () => 
      { 
        let template = TemplatesList.FORGOT_PASSWORD_OVERLAY;

        let onSend = async ( email:string, pw:string )=>
        {
          let requestSent = await Rokojori.$.userSystem.requestPasswordChange( email );

          console.log( requestSent );

          return Promise.resolve( requestSent )
        }

        EmailOverlay.open( template, onSend, true ); 
      } 
    );
  }

}